<template>
  <app-page-wrapper
    class="grid place-content-center"
    data-cy-catalog-navigation
  >
    <nav class="max-w-full overflow-hidden">
      <ul class="no-scrollbar flex items-center gap-2 overflow-auto">
        <li v-for="item in items" :key="item.label">
          <nuxt-link
            class="group grid min-h-[54px] grid-cols-[36px_min-content] items-center gap-3 rounded-lg bg-[--bg] pl-2 pr-4 text-sm font-[500] outline-none ring-inset ring-[--bdHover] transition-all hover:ring-[1px] focus-visible:ring-[1px]"
            exact-active-class="!ring-[--bdActive] ring-[1px]"
            :style="{
              '--bg': hexToHSLA(item.color, {
                luminance: 55,
                saturation: 80,
                alpha: 10,
              }),
              '--bgIcon': hexToHSLA(item.color, {
                luminance: 50,
                saturation: 80,
                alpha: 10,
              }),
              '--text': hexToHSLA(item.color, {
                luminance: 40,
                saturation: 65,
                alpha: 100,
              }),
              '--bdHover': hexToHSLA(item.color, {
                luminance: 55,
                saturation: 80,
                alpha: 30,
              }),
              '--bdActive': hexToHSLA(item.color, {
                luminance: 55,
                saturation: 70,
                alpha: 60,
              }),
            }"
            :to="item.to"
          >
            <app-icon
              class="rounded bg-[--bgIcon] p-2 text-[--text]"
              :icon="item.active ? iconFillVariant(item.icon) : item.icon"
              :size="40"
            />
            <span
              :class="{ 'whitespace-nowrap': item.label.length < 15 }"
              v-html="item.label"
            />
          </nuxt-link>
        </li>
      </ul>
    </nav>
  </app-page-wrapper>
</template>

<script lang="ts" setup>
import { iconFillVariant } from "@pollen/ui-library";

import { hexToHSLA } from "#imports";
import { type RouteLocationRaw } from "#vue-router";
import { ALL_CATALOG_ENTRY_COLOR } from "~/business-areas/tag-page/tag-page.model";

const properties = defineProps<{
  baseRouteItem?: boolean;
}>();

const { data: tagPages } = useTagPageList();
const router = useRouter();
const route = useRoute();

const items = computed<
  {
    label: string;
    to: RouteLocationRaw;
    color: string;
    icon: string;
    active: boolean;
  }[]
>(() => {
  return [
    ...(properties.baseRouteItem
      ? [
          {
            label: "Tout l'intra",
            to: { name: "catalog-index" as const },
            color: ALL_CATALOG_ENTRY_COLOR,
            icon: "ph:building-office",
          },
        ]
      : []),
    ...tagPages.value.map((tagPage) => {
      return {
        label: tagPage.tag.label.replaceAll(/(& |\/ )/g, "&&nbsp;"),
        to: tagPage._links.page,
        color: tagPage.tag.color,
        icon: tagPage.tag.icon,
      };
    }),
  ].map((item) => {
    return {
      ...item,
      active: router.resolve(item.to).path === route.path,
    };
  });
});
</script>
